import toDocument from '@/shared/directive/toDocument';

type ContractNotBilledType = {
  id: string | null
  number: string
  resultCenter: string
  beneficiary: string
  customerTradingName: string
  customerName: string
  customerDocument: string
  externalId: number
}

export default class ContractNotBilled {
  id: string | null

  contractNumber: String

  resultCenter: string

  beneficiary: string

  customerTradingName: String

  customerName: String

  customerDocument: String

  externalId: number

  private constructor(obj: ContractNotBilledType) {
    this.id = obj.id || null
    this.contractNumber = obj.number || ''
    this.resultCenter = obj.resultCenter || ''
    this.beneficiary = obj.beneficiary || ''
    this.customerTradingName = obj.customerTradingName || ''
    this.customerName = obj.customerName || ''
    this.customerDocument = toDocument(obj.customerDocument) || ''
    this.externalId = obj.externalId
  }

  public static of(obj: any) {
    return new ContractNotBilled(obj || {})
  }

  public static ofList(obj: any[]): ContractNotBilled[] {
    return obj.map(this.of)
  }
}
